export function getInstrumentSymbolPreffix(symbol?: string) {
  if (!symbol) return '';
  return symbol.substring(0, 4);
}
